import { pr } from '@/utils/pxToRem';
import { Typography, Stack } from '@mui/material';
import React from 'react';
import { style } from '@/styles/globals';
import Image from 'next/image';
import { loaderImageVex } from '@/utils/loadImageSeoVex';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

const SocialNetwork = ({ lang }: { lang?: ILangObj }) => (
  <Stack spacing={pr`16px`}>
    <Typography
      component="div"
      sx={{
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '30px',
        color: `${style.color.black1}`,
      }}
    >
      {lang?.footer?.followUs.title || 'Theo dõi chúng tôi trên'}
    </Typography>
    <Stack
      spacing={pr`20px`}
      marginTop={pr`23px`}
    >
      <Stack
        spacing={pr`20px`}
        flexWrap="wrap"
        justifyContent="flex-start"
        direction="row"
      >
        <div>
          <Image
            loader={loaderImageVex}
            src="https://storage.googleapis.com/goyolo-uat/images/SN/facebook.svg"
            alt="logo"
            width="24px"
            height="24px"
            objectFit="contain"
          />

        </div>
        <div>
          <Image
            loader={loaderImageVex}
            src="https://storage.googleapis.com/goyolo-uat/images/SN/Youtube.svg"
            alt="logo"
            width="24px"
            height="24px"
            objectFit="contain"
          />

        </div>
        <div>
          <Image
            loader={loaderImageVex}
            src="https://storage.googleapis.com/goyolo-uat/images/SN/GooglePlusCircle.svg"
            alt="logo"
            width="24px"
            height="24px"
            objectFit="contain"
          />

        </div>
      </Stack>
    </Stack>
  </Stack>
);

export default SocialNetwork;
